/**
 * Échappe une valeur pour l'export CSV
 * @param value - La valeur à échapper
 * @returns La valeur échappée pour CSV
 */
export const escapeCsvValue = (value: any): string => {
  if (value === null || value === undefined) {
    return '""';
  }

  const stringValue = String(value);

  // Si la valeur contient des virgules, des guillemets ou des retours chariot, on l'entoure de guillemets
  if (
    stringValue.includes(",") ||
    stringValue.includes('"') ||
    stringValue.includes("\n") ||
    stringValue.includes("\r")
  ) {
    // Échapper les guillemets doubles en les doublant
    return `"${stringValue.replace(/"/g, '""')}"`;
  }

  return stringValue;
};

/**
 * Convertit un tableau de données en contenu CSV (usage interne)
 * @param headers - Les en-têtes des colonnes
 * @param rows - Les lignes de données
 * @returns Le contenu CSV formaté
 */
const arrayToCsv = (headers: string[], rows: any[][]): string => {
  const csvRows = [
    headers.map(escapeCsvValue).join(","),
    ...rows.map((row) => row.map(escapeCsvValue).join(",")),
  ];

  return csvRows.join("\n");
};

/**
 * Crée un Blob CSV avec le bon encodage UTF-8 et BOM pour Excel
 * @param headers - Les en-têtes des colonnes
 * @param rows - Les lignes de données
 * @returns Le Blob CSV avec encodage correct
 */
export const createCsvBlob = (headers: string[], rows: any[][]): Blob => {
  const csvContent = arrayToCsv(headers, rows);

  // Ajouter le BOM UTF-8 pour Excel
  const BOM = "\uFEFF";
  const csvWithBOM = BOM + csvContent;

  return new Blob([csvWithBOM], {
    type: "text/csv;charset=utf-8;",
  });
};
